import { Fragment } from 'react';

import { FeedbackDialogContextProvider } from './FeedbackDialogContext';
import { FeedbackToaster } from './FeedbackToaster';
import { SkillFeedbackModalContextProvider, useSkillFeedbackModalContext } from './ModalContext';
import { SkillFeedbackModal } from './SkillFeedbackModal';
import { LayoutThemeProvider } from '../job-architecture/LayoutThemeProvider';
import { SkillFeedbackButton } from '../job-architecture/SkillFeebackButton';

import type { FunctionComponent, PropsWithChildren } from 'react';

const SkillFeedbackModalProviderWithoutFab: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const { isOpen } = useSkillFeedbackModalContext();

    return (
        <Fragment>
            {children}
            {isOpen && (
                <FeedbackDialogContextProvider>
                    <SkillFeedbackModal />
                </FeedbackDialogContextProvider>
            )}
            <FeedbackToaster />
        </Fragment>
    );
};

export const SkillFeedbackModalProvider: FunctionComponent<
    PropsWithChildren & { readonly isWithFloatingActionButton: boolean }
> = ({ children, isWithFloatingActionButton }) => {
    if (isWithFloatingActionButton === false) {
        return <SkillFeedbackModalProviderWithoutFab>{children}</SkillFeedbackModalProviderWithoutFab>;
    }

    return (
        <Fragment>
            {children}
            <FeedbackDialogContextProvider>
                <LayoutThemeProvider>
                    <SkillFeedbackButton />
                    <SkillFeedbackModal />
                </LayoutThemeProvider>
            </FeedbackDialogContextProvider>
            <FeedbackToaster />
        </Fragment>
    );
};

export const SkillFeedbackModalRoot: FunctionComponent<
    PropsWithChildren & { readonly isWithFloatingActionButton?: boolean }
> = ({ children, isWithFloatingActionButton = false }) => {
    return (
        <SkillFeedbackModalContextProvider>
            <SkillFeedbackModalProvider isWithFloatingActionButton={isWithFloatingActionButton}>
                {children}
            </SkillFeedbackModalProvider>
        </SkillFeedbackModalContextProvider>
    );
};
